<div class="reveal-overlay">
  <div class="reveal sign-in sign-in--password">
    <mono-common-modal-header
      signInHeader="true"
      [headerText]="signInCms?.data?.attributes?.header"
    ></mono-common-modal-header>
    <main id="content" #content>
      <ng-container *ngIf="signInEmail">
        <ul class="no-bullet sign-in__icons-list margin-bottom-0">
          <li class="icon-on-left">
            <svg class="icon icon--email" width="24" height="24">
              <use xlink:href="#icon-email" href="#icon-email"></use>
            </svg>
            <span>{{ signInAttribute }}</span>
          </li>
          <li>
            <a class="button button--icon-on-left clear" [routerLink]="signInUsernameStage" queryParamsHandling="preserve">
              <svg class="icon icon--arrow-left" width="20" height="20">
                <use
                  xlink:href="#icon-arrow-left"
                  href="#icon-arrow-left"
                ></use>
              </svg>
              <span
                >{{ signInCms?.data?.attributes?.password?.emailNotRight }}</span
              >
            </a>
          </li>
        </ul>
      </ng-container>
      <ng-container *ngIf="!signInEmail">
        <ul class="no-bullet sign-in__icons-list margin-bottom-0">
          <li class="icon-on-left padding-bottom-1">
            <svg class="icon icon--mobile" width="24" height="24">
              <use xlink:href="#icon-mobile" href="#icon-mobile"></use>
            </svg>
            <span>{{ phoneNumberWithoutCountryCodeForDisplay }}</span>
          </li>
          <li>
            <a class="button button--icon-on-left clear" [routerLink]="signInUsernameStage" queryParamsHandling="preserve">
              <svg class="icon icon--arrow-left" width="20" height="20">
                <use
                  xlink:href="#icon-arrow-left"
                  href="#icon-arrow-left"
                ></use>
              </svg>
              <span
                >{{ signInCms?.data?.attributes?.password?.mobileNotRight }}</span
              >
            </a>
          </li>
        </ul>
      </ng-container>
      <hr />
      <div class="position-relative">
        <section
          attr.role="alert"
          tabindex="-1"
          class="enter-code-popout padding-top-0-5"
          [ngStyle]="
            showResetCodeSlider
              ? { 'top.px': 0, opacity: 1  }
              : { 'top.px': slideTopPosition, opacity: 1 }
          "
          #sendResetCodeSlider
        >
          <mono-common-callout *ngIf="signInEmail"
            base="info"
            type="info-text"
            animation="no-animation"
            [calloutText]="signInCms?.data?.attributes?.password?.forgotPasswordSlider?.emailInformation"
            paddingOrMarginAlteration="padding-bottom-1"
            >
          </mono-common-callout>
          <mono-common-callout *ngIf="!signInEmail"
            base="info"
            type="info-text"
            animation="no-animation"
            [calloutText]="signInCms?.data?.attributes?.password?.forgotPasswordSlider?.mobileInformation"
          >
          </mono-common-callout>
          <button
            type="button"
            class="button hollow primary small button--icon-on-left"
            (click)="sendPasswordCode()"
            [disabled]="disableSendButton"
          >
            <svg
              *ngIf="!showSendingLoader && signInEmail"
              class="icon icon--send-code icon--primary-dark icon--material"
              viewBox="0 0 24 24"
              width="150"
              height="150"
            >
              <use
                xlink:href="#icon-send-code-email"
                href="#icon-send-code-email"
              ></use>
            </svg>
            <svg
              *ngIf="!showSendingLoader && !signInEmail"
              class="icon icon--send-code icon--send-code-mobile icon--primary-dark icon--material"
              viewBox="0 0 24 24"
              width="150"
              height="150"
            >
              <use
                xlink:href="#icon-send-code-mobile"
                href="#icon-send-code-mobile"
              ></use>
            </svg>
            <mono-common-loading-animation
              *ngIf="showSendingLoader"
            ></mono-common-loading-animation>
            <span class="text-left"
              *ngIf="!showSendingLoader"
              >{{ signInCms?.data?.attributes?.password?.forgotPasswordSlider?.sendNumberButton }}</span
            >
            <span class="text-left"
              *ngIf="showSendingLoader"
              >{{ signInCms?.data?.attributes?.password?.forgotPasswordSlider?.sendingNumberLoader }}</span
            >
          </button>
          <hr class="margin-top-1" />
          <button [attr.aria-label]="signInCms?.data?.attributes?.password?.forgotPasswordSlider?.rememberedPasswordAriaLabel"
            type="button"
            class="button clear underline button--icon-on-left button--restart text-center"
            (click)="hideCodeSlider()"
          >
            <svg
              class="icon icon--restart icon--material centered-button"
              viewBox="0 0 24 24"
              width="150"
              height="150"
            >
              <use xlink:href="#icon-restart" href="#icon-restart"></use>
            </svg>
            <span
              class="text-left"
              >{{ signInCms?.data?.attributes?.password?.forgotPasswordSlider?.rememberedPassword }}</span
            >
          </button>
        </section>
      </div>
      <form [formGroup]="signInPasswordForm" #passwordForm
      >
        <fieldset [disabled]="showResetCodeSlider">
          <legend class="show-for-sr">{{ signInCms?.data?.attributes?.password?.screenReaderLegend }}</legend>
          <label for="password">{{ signInCms?.data?.attributes?.password?.label }}</label>
          <div class="input-group--password input-group--with-link">
            <mono-common-input-with-done-button
              (doneButtonClick)="doneButtonClicked()"
              [disableDoneButton]="(signInPasswordForm.get('password') && signInPasswordForm.get('password').errors) || canNavigate"
              [language]="authProcessProvider.language"
            >
            <ng-container input>
              <mono-common-password-input
                (inputReady)="signInPasswordForm.addControl('password', $event)"
              >
              <ng-container input>
                <input
                  *ngIf="signInPasswordForm.get('password')"
                  class="input-group-field"
                  [type]="showPassword ? 'text' : 'password'"
                  id="password"
                  #passwordInput
                  formControlName="password"
                  autocomplete="current-password"
                  name="password"
                  maxlength="50"
                  aria-labelledby="passwordAriaId"
                  (focus)="onPasswordInputFocus()"
                  (blur)="inputBlurred()"
                  aria-required="true"
                />
              </ng-container>
            </mono-common-password-input>
              <mono-common-show-hide-password-toggle
                [language]="authProcessProvider.language"
                (showToggle)="showPasswordToggle($event)"
              ></mono-common-show-hide-password-toggle>
            </ng-container>
            </mono-common-input-with-done-button>
          </div>
          <button
            type="button"
            class="button clear underline"
            (click)="showCodeSlider()"
          >
            <span
              >{{ signInCms?.data?.attributes?.password?.forgottenMyPassword }}</span
            >
          </button>
        </fieldset>
        <div class="form-disabled-overlay" [ngClass]="showResetCodeSlider || showFeedbackCallout === 'tooManyPasswordAttempts' ? 'fade-up' : 'hide'" aria-hidden="true"></div>
        <mono-common-help
          [action]="signInUserErrorAction"
          helpPopupCalledFrom="password"
          [title]="signInCms?.data?.attributes?.password?.incorrectPasswordHelp?.title"
          [message]="signInCms?.data?.attributes?.password?.incorrectPasswordHelp?.message"
          [closeButtonText]="signInCms?.data?.attributes?.password?.incorrectPasswordHelp?.closeButtonText"
          (closeButtonExtras)="helpMessageClose()"
          [removeHelpMessage]="removeHelpMessage"
          [elementAttachedTo]="_passwordInput"
        ></mono-common-help>
      </form>
    </main>
    <div [attr.aria-hidden]="showFeedbackCallout === 'tooManyCodeAttempts' ? 'false' : 'true'"
      class="feedback-callout feedback-callout--message-slider feedback-callout--message-slider--password flex-container align-center"
      [ngStyle]="showFeedbackCallout === 'tooManyCodeAttempts' ? { transform: 'translate(-50%, 0' } : {  transform: 'translate(-50%, 105%)' }"
    >
      <mono-common-callout
        data-test="lmw-auth-error-callout--info"
        base="info"
        type="info-box"
        [error]="true"
        [calloutText]="signInCms?.data?.attributes?.password?.tooManyCodeRequestsError?.text"
        [errorDescription]="signInCms?.data?.attributes?.password?.tooManyCodeRequestsError?.errorDescription"

      ></mono-common-callout>
    </div>
    <div [attr.aria-hidden]="showFeedbackCallout === 'tooManyPasswordAttempts' ? 'false' : 'true'"
      class="feedback-callout feedback-callout--message-slider feedback-callout--message-slider--password flex-container align-center"
      [ngStyle]="showFeedbackCallout === 'tooManyPasswordAttempts' ? { transform: 'translate(-50%, 0' } : {  transform: 'translate(-50%, 105%)' }"
    >
      <mono-common-callout
        data-test="lmw-auth-error-callout--info"
        base="info"
        type="info-box"
        [error]="true"
        [calloutText]="signInCms?.data?.attributes?.password?.tooManyIncorrectPasswordAttemptsError?.text"
        [errorDescription]="signInCms?.data?.attributes?.password?.tooManyIncorrectPasswordAttemptsError?.errorDescription"

      ></mono-common-callout>
    </div>
    <footer class="footer--sign-in footer--sign-in--password" #footer [ngStyle]="moveFooterUnderPasswordErrorHelp ? { 'z-index': 99 } : ''"
    >
      <div class="button-container">
        <button
          [disabled]="!canNavigate || (showSignInLoader | async) || showResetCodeSlider"
          (click)="signInButtonClicked()"
          type="button"
          class="button primary expanded with-shadow"
        >
          <span
            *ngIf="!(showSignInLoader | async)"
            >{{ signInCms?.data?.attributes?.password?.signInButton }}</span
          >
          <ng-container *ngIf="showSignInLoader | async">
            <span
              >{{ signInCms?.data?.attributes?.password?.signingInLoader }}</span
            >
            <mono-common-loading-animation></mono-common-loading-animation>
          </ng-container>
        </button>
      </div>
    </footer>
  </div>
</div>
